import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { WebSocketService } from '../../../shared/services/web-socket/web-socket.service';

@Component({
  selector: 'semeris-connection-status-indicator',
  imports: [MatIconModule, FastTooltipDirective],
  templateUrl: './connection-status-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-flex rounded-full bg-neutral-0 leading-none',
  },
})
export class ConnectionStatusIndicatorComponent {
  private readonly ws = inject(WebSocketService);

  public readonly status = this.ws.connectionStatus;
}
